type Props = {
  dateFrom: string;
  dateTo: string;
  onChange: (next: { dateFrom: string; dateTo: string }) => void;
};

export default function DateRangePicker({ dateFrom, dateTo, onChange }: Props) {
  return (
    <div className="ds-daterange">
      <span className="ds-daterange-label">From</span>
      <input
        type="date"
        value={dateFrom}
        max={dateTo}
        onChange={(e) => onChange({ dateFrom: e.target.value, dateTo })}
      />
      <span className="arrow">→</span>
      <span className="ds-daterange-label">To</span>
      <input
        type="date"
        value={dateTo}
        min={dateFrom}
        onChange={(e) => onChange({ dateFrom, dateTo: e.target.value })}
      />
    </div>
  );
}
